module.exports = __webpack_public_path__ + "static/media/eu-china.f26e5714.jpg";